export default {"src":"/_next/static/media/c_Gold_1.c941df33.svg","height":92,"width":88,"blurWidth":0,"blurHeight":0};